// // src/components/Category.js

// import React, { useState, useEffect } from "react";
// import axios from "axios"; // Убедитесь, что axios установлен: npm install axios
// import "../styles/Category.css";

// const Category = () => {
//     // Состояния для данных из API /items/Kategorien
//     const [kategorien, setKategorien] = useState([]);
//     const [loadingKategorien, setLoadingKategorien] = useState(true);
//     const [errorKategorien, setErrorKategorien] = useState(null);

//     // URL вашего API
//     const KATEGORIEN_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Kategorien?fields=*.*';

//     useEffect(() => {
//         const fetchKategorien = async () => {
//             try {
//                 const response = await axios.get(KATEGORIEN_API_URL);
//                 if (response.data && response.data.data) {
//                     setKategorien(response.data.data);
//                 } else {
//                     setErrorKategorien('Нет данных для отображения');
//                 }
//             } catch (error) {
//                 setErrorKategorien('Ошибка при получении данных');
//                 console.error(error);
//             } finally {
//                 setLoadingKategorien(false);
//             }
//         };

//         fetchKategorien();
//     }, []);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         // Используем /assets/ для доступа к иконкам
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     return (
//         <div className="category">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Kategorien im Detail</span>
//             </h1>

//             {/* Обработка состояний загрузки и ошибок */}
//             {loadingKategorien && <p>Загрузка категорий...</p>}
//             {errorKategorien && <p>{errorKategorien}</p>}

//             {/* Отображение категорий */}
//             {!loadingKategorien && !errorKategorien && (
//                 <div className="cards2">
//                     {kategorien.map((kategorie) => {
//                         const iconUrl = getIconUrl(kategorie.Icon);
//                         console.log(`Icon URL for Kategorie ID ${kategorie.id}: ${iconUrl}`);

//                         return (
//                             <div key={kategorie.id} className="card-wrapper2">
//                                 <div className="card2">
                                    
//                                     <p>{kategorie.Name}</p>

//                                     {/* Отображение иконки */}
//                                     {iconUrl ? (
//                                         <img
//                                             src={iconUrl}
//                                             alt={kategorie.Name}
//                                             className="category-icon"
//                                             loading="lazy" // Ленивая загрузка изображений
//                                             onError={(e) => { e.target.onerror = null; e.target.src = '/path/to/placeholder.png'; }} // Плейсхолдер при ошибке загрузки
//                                         />
//                                     ) : (
//                                         <div className="category-icon-placeholder"></div>
//                                     )}
//                                 </div>
//                             </div>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Category;


// src/components/Category.js






// import React, { useState, useEffect } from "react";
// import axios from "axios"; // Убедитесь, что axios установлен: npm install axios
// import { Link } from "react-router-dom"; // Импортируем Link для навигации
// import "../styles/Category.css";
// import Loader from "./Loader";

// const Category = () => {
//     // Состояния для данных из API /items/Kategorien
//     const [kategorien, setKategorien] = useState([]);
//     const [loadingKategorien, setLoadingKategorien] = useState(true);
//     const [errorKategorien, setErrorKategorien] = useState(null);

//     // URL вашего API
//     const KATEGORIEN_API_URL = process.env.REACT_APP_API_BASE_URL + '/items/Kategorien?fields=*.*';

//     useEffect(() => {
//         const fetchKategorien = async () => {
//             try {
//                 const response = await axios.get(KATEGORIEN_API_URL);
//                 if (response.data && response.data.data) {
//                     setKategorien(response.data.data);
//                 } else {
//                     setErrorKategorien('Keine Data');
//                 }
//             } catch (error) {
//                 setErrorKategorien('Error');
//                 console.error(error);
//             } finally {
//                 setLoadingKategorien(false);
//             }
//         };

//         fetchKategorien();
//     }, []);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         // Используем /assets/ для доступа к иконкам
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     return (
//         <div className="category">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Kategorien im Detail</span>
//             </h1>

//             {/* Обработка состояний загрузки и ошибок */}
//             {loadingKategorien && <Loader/>}
//             {errorKategorien && <p>{errorKategorien}</p>}

//             {/* Отображение категорий */}
//             {!loadingKategorien && !errorKategorien && (
//                 <div className="cards2">
//                     {kategorien.map((kategorie) => {
//                         const iconUrl = getIconUrl(kategorie.Icon);
//                         console.log(`Icon URL for Kategorie ID ${kategorie.id}: ${iconUrl}`);

//                         return (
//                             <Link 
//                                 to={`/details/${kategorie.id}`} 
//                                 key={kategorie.id} 
//                                 className="card-wrapper2"
//                                 style={{ textDecoration: 'none', color: 'inherit' }} // Убираем подчеркивание и наследуем цвет
//                             >
//                                 <div className="card2">
//                                     {/* Отображение иконки */}
//                                     {iconUrl ? (
//                                         <img
//                                             src={iconUrl}
//                                             alt={kategorie.Name}
//                                             className="category-icon"
//                                             loading="lazy" // Ленивая загрузка изображений
//                                             onError={(e) => { e.target.onerror = null; e.target.src = '/images/placeholder.png'; }} // Плейсхолдер при ошибке загрузки
//                                         />
//                                     ) : (
//                                         <div className="category-icon-placeholder"></div>
//                                     )}
//                                     <p>{kategorie.Name}</p>
//                                 </div>
//                             </Link>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Category;



// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import "../styles/Category.css";
// import Loader from "./Loader";
// import { CategoryContext } from '../contexts/CategoryContext';

// const Category = () => {
//     const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     return (
//         <div className="category">
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Kategorien im Detail</span>
//             </h1>

//             {/* Обработка состояний загрузки и ошибок */}
//             {loadingKategorien && <Loader/>}
//             {errorKategorien && <p>{errorKategorien}</p>}

//             {/* Отображение категорий */}
//             {!loadingKategorien && !errorKategorien && (
//                 <div className="cards2">
//                     {kategorien.map((kategorie) => {
//                         const iconUrl = getIconUrl(kategorie.Icon);
//                         console.log(`Icon URL for Kategorie ID ${kategorie.id}: ${iconUrl}`);

//                         return (
//                             <Link 
//                                 to={`/details/${kategorie.id}`} 
//                                 key={kategorie.id} 
//                                 className="card-wrapper2"
//                                 style={{ textDecoration: 'none', color: 'inherit' }}
//                             >
//                                 <div className="card2">
//                                     {/* Отображение иконки */}
//                                     {iconUrl ? (
//                                         <img
//                                             src={iconUrl}
//                                             alt={kategorie.Name}
//                                             className="category-icon"
//                                             loading="lazy"
//                                             onError={(e) => { e.target.onerror = null; e.target.src = '/images/placeholder.png'; }}
//                                         />
//                                     ) : (
//                                         <div className="category-icon-placeholder"></div>
//                                     )}
//                                     <p>{kategorie.Name}</p>
//                                 </div>
//                             </Link>
//                         );
//                     })}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Category;


// src/components/Category.js

import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import "../styles/Category.css";
import styles from "../styles/Class.module.css";
import Loader from "./Loader";
import InlineSvg from './InlineSvg';
import { CategoryContext } from '../contexts/CategoryContext';
import { ClassContext } from '../contexts/ClassContext';

const Category = () => {
    const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);
    const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);
    const [openCat, setOpenCat] = useState(null);

    const toggleCat = (cid) => {
        openCat === cid ? setOpenCat(null) : setOpenCat(cid);
    };

    // Функция для формирования URL иконки / Funktion zur Erstellung der URL für das Icon
    const getIconUrl = (icon) => {
        if (!icon || !icon.filename_disk) return null;
        const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
        return `${baseUrl}${icon.filename_disk}`;
    };

    // Разделение категорий на Hauptkategorie и Zusatzkategorie / Aufteilung der Kategorien in Hauptkategorie und Zusatzkategorie
    const hauptKategorien = kategorien.filter(kategorie => kategorie.Hauptkategorie === true);
    const zusatzKategorien = kategorien.filter(kategorie => kategorie.Hauptkategorie === false);

    const groupByCategory = (klassen) => {
        return klassen.reduce((acc, klasse) => {
            const kategorien = klasse.Kategorien || [];
            kategorien.forEach((kategorieRelation) => {
                const categoryName = kategorieRelation.Kategorien_id?.Name || "Keine Kategorie";

                // Исключаем категорию "Anhänger" / Ausschluss der Kategorie "Anhänger"
                // if (categoryName.toLowerCase() === 'anhänger') {
                //    return;
                //}

                /* if(!kategorieRelation.Kategorien_id.Hauptkategorie) {
                    return;
                } */

                if (!acc[categoryName]) {
                    acc[categoryName] = [];
                }
                acc[categoryName].push(klasse);
            });
            return acc;
        }, {});
    };

    // Сгруппированные данные / Gruppierte Daten
    const groupedKlassen = groupByCategory(klassen);

    return (
        <section className="category">
            <div className="category-container">
                {/* <h1 className="title-category">
                    Dein Weg. Dein Ziel. <span>Dein Führerschein.</span>
                </h1>
                <p><strong>Mach aus „irgendwann“ einfach „jetzt“.</strong> <br />Dein Führerschein wartet. Wir haben alles, was du brauchst, um durchzustarten.</p> */}
                <h1 className="title-category">
                    Mach dich bereit –<br /> <span>dein Führerschein wartet!</span>
                </h1>
                <p>Egal, ob du auf zwei Rädern den Fahrtwind genießen, mit dem Auto die Straßen erobern oder richtig große Maschinen bewegen willst – wir machen dich startklar.</p>

                {/* Обработка состояний загрузки и ошибок / Verarbeitung von Ladezuständen und Fehlern */} 
                {loadingKategorien && <Loader />}
                {errorKategorien && <p className="error">{errorKategorien}</p>}

                {/* Отображение Hauptkategorie / Anzeige der Hauptkategorie */}
                {!loadingKategorien && !errorKategorien && (
                    <div>
                        {/* Основные категории / Hauptkategorien */}
                        <div className="hauptkategorien-section">
                            <div className="cards2">
                                {hauptKategorien.map((kategorie, idx) => {
                                    const iconUrl = getIconUrl(kategorie.Icon);
                                    //const isOpen = openCat.has(kategorie.id);

                                    return (
                                        <React.Fragment key={kategorie.id} >
                                            <div 
                                                /* to={`/category/${kategorie.id}`} */
                                                
                                                className={`card2 ${openCat === kategorie.id ? 'open' : ''}`}
                                                onClick={() => toggleCat(kategorie.id)}
                                            >
                                                <div className="card2-content">
                                                    <h3 dangerouslySetInnerHTML={{__html:kategorie.Name}} />
                                                    {kategorie.Beschreibung && (<p>{kategorie.Beschreibung}</p>)}
                                                </div>
                                                {iconUrl ? (
                                                    iconUrl.endsWith('.svg') ? (
                                                        <InlineSvg
                                                        src={iconUrl}
                                                        alt={kategorie.Name}
                                                        className="category-icon"
                                                        fallback="/images/placeholder.png"
                                                        />
                                                    ) : (
                                                        <img
                                                        src={iconUrl}
                                                        alt={kategorie.Name}
                                                        className="category-icon"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/assets/placeholder.svg';
                                                        }}
                                                        />
                                                    )
                                                ) : (
                                                    <div className="category-icon-placeholder" />
                                                )}
                                            </div>
                                            <div className={`category-classes category-row-${idx + 1}`}>
                                                <div className="classes-container">
                                                    <div key={kategorie.id} className="classWrap">
                                                        {klassen.length > 0 && (
                                                            <div className="cards3">
                                                                {klassen
                                                                    /* .filter(klasse => klasse.Kategorien.Kategorien_id.id === category.id) */
                                                                    .filter(klasse => klasse.Kategorien.find(kat => kat.Kategorien_id.id === kategorie.id))
                                                                    .map((klasse) => (
                                                                        <Link to={`/klassen/${kategorie.Name.toLowerCase()}/${klasse.slug}`} key={klasse.id} className="card3 card-link">
                                                                            {/* Отображение иконки / Anzeige des Icons */}
                                                                            <hgroup>
                                                                                <div>
                                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                                        <div className="klasse-icon">
                                                                                            { getIconUrl(klasse.Icon).endsWith('.svga') ? (
                                                                                                <InlineSvg
                                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                                    alt={klasse.Name}
                                                                                                    loading="lazy"
                                                                                                    onError={(e) => {
                                                                                                        e.target.onerror = null;
                                                                                                        e.target.src = "/images/placeholder.png";
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <img
                                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                                    alt={klasse.Name}
                                                                                                    loading="lazy"
                                                                                                    onError={(e) => {
                                                                                                        e.target.onerror = null;
                                                                                                        e.target.src = "/images/placeholder.png";
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div>No Icon</div>
                                                                                    )}
                                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                                </div>
                                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                                            </hgroup>
                                                                            <p>{klasse.icon_text}</p>
                                                                        </Link>
                                                                    ))
                                                                }
                                                            </div>
                                                        )}
                        
                                                            {/* Отображение Zusatzausbildungen, если они есть / Anzeige der Zusatzausbildungen, falls vorhanden */}
                                                            {klassen
                                                                .filter(klasse => kategorie.Zusatzausbildungen?.find(klid => klid.Klassen_id === klasse.id))
                                                                .length > 0 && (
                                                                <div className="zusatz-section">
                                                                    <h3 className="zusatz-anhaenger-class">Zusatzausbildungen für {kategorie.Name}</h3>
                                                                    <div className="cards3">
                                                                        {klassen
                                                                            .filter(klasse => kategorie.Zusatzausbildungen?.find(klid => klid.Klassen_id === klasse.id))
                                                                            .map((klasse) => (
                                                                            <Link to={`/klassen/${kategorie.Name.toLowerCase()}/${klasse.slug}`} key={klasse.id} className="card3 card-link">
                                                                                {/* Отображение иконки / Anzeige des Icons */}
                                                                                <hgroup>
                                                                                    <div>
                                                                                        {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                                            <div className="klasse-icon">
                                                                                                { getIconUrl(klasse.Icon).endsWith('.svga') ? (
                                                                                                    <InlineSvg
                                                                                                        src={getIconUrl(klasse.Icon)}
                                                                                                        alt={klasse.Name}
                                                                                                        loading="lazy"
                                                                                                        onError={(e) => {
                                                                                                            e.target.onerror = null;
                                                                                                            e.target.src = "/images/placeholder.png";
                                                                                                        }}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <img
                                                                                                        src={getIconUrl(klasse.Icon)}
                                                                                                        alt={klasse.Name}
                                                                                                        loading="lazy"
                                                                                                        onError={(e) => {
                                                                                                            e.target.onerror = null;
                                                                                                            e.target.src = "/images/placeholder.png";
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div>No Icon</div>
                                                                                        )}
                                                                                        { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                                    </div>
                                                                                    { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                                                </hgroup>
                                                                                <p>{klasse.icon_text}</p>
                                                                            </Link>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                </div>
                                            </div> 
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Дополнительные категории / Zusatzkategorien */}
                        <div className="zusatzkategorien-section">
                           {/*  <h2 className="section-title">Und noch vieles mehr...</h2> */}
                            <div className="cards2">
                                {zusatzKategorien.map((kategorie, idx) => {
                                    const iconUrl = getIconUrl(kategorie.Icon);
                                    return (
                                        <React.Fragment key={kategorie.id}>
                                            <div 
                                                /* to={`/category/${kategorie.id}`} */  
                                                className={`card2 ${openCat === kategorie.id ? 'open' : ''}`}
                                                onClick={() => toggleCat(kategorie.id)}
                                            >
                                                <h3 dangerouslySetInnerHTML={{__html:kategorie.Name}} />
                                                {/* Отображение иконки / Anzeige des Icons */}
                                                {iconUrl ? (
                                                    iconUrl.endsWith('.svg') ? (
                                                        <InlineSvg
                                                        src={iconUrl}
                                                        alt={kategorie.Name}
                                                        className="category-icon"
                                                        fallback="/images/placeholder.png"
                                                        />
                                                    ) : (
                                                        <img
                                                        src={iconUrl}
                                                        alt={kategorie.Name}
                                                        className="category-icon"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/assets/placeholder.svg';
                                                        }}
                                                        />
                                                    )
                                                ) : (
                                                    <div className="category-icon-placeholder" />
                                                )}
                                            </div>
                                            <div className={`category-classes category-row-${idx + 1}`}>
                                                <div className="classes-container">
                                                    {!loadingKlassen && !errorKlassen && (
                                                        <div>
                                                            {Object.keys(groupedKlassen).map((category) => {
                                                                if(category === kategorie.Name) {
                                        
                                                                    return (
                                                                        <div key={category} className="zusatz-section">
                                                                            {/* Отображение стандартных классов / Anzeige der Standardklassen */}
                                                                            {groupedKlassen[category].length > 0 && (
                                                                                <div className="cards3">
                                                                                    {groupedKlassen[category].map((klasse) => (
                                                                                        <Link to={`/klassen/${kategorie.Name.toLowerCase()}/${klasse.slug}`} key={klasse.id} className="card3 card-link">
                                                                                            {/* Отображение иконки / Anzeige des Icons */}
                                                                                            <hgroup>
                                                                                                <div>
                                                                                                    {klasse.Icon && klasse.Icon.filename_disk ? (
                                                                                                        <div className="klasse-icon">
                                                                                                            { getIconUrl(klasse.Icon).endsWith('.svga') ? (
                                                                                                                <InlineSvg
                                                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                                                    alt={klasse.Name}
                                                                                                                    loading="lazy"
                                                                                                                    onError={(e) => {
                                                                                                                        e.target.onerror = null;
                                                                                                                        e.target.src = "/images/placeholder.png";
                                                                                                                    }}
                                                                                                                />
                                                                                                            ) : (
                                                                                                                <img
                                                                                                                    src={getIconUrl(klasse.Icon)}
                                                                                                                    alt={klasse.Name}
                                                                                                                    loading="lazy"
                                                                                                                    onError={(e) => {
                                                                                                                        e.target.onerror = null;
                                                                                                                        e.target.src = "/images/placeholder.png";
                                                                                                                    }}
                                                                                                                />
                                                                                                            )}
                                                                                                        </div>
                                                                                                    ) : (
                                                                                                        <div>No Icon</div>
                                                                                                    )}
                                                                                                    { klasse.Klassenkuerzel ? <h3>{klasse.Klassenkuerzel}</h3> : ''}
                                                                                                </div>
                                                                                                { klasse.Untertitel ? <p>{klasse.Untertitel}</p> : ''}
                                                                                            </hgroup>
                                                                                            <p>{klasse.icon_text}</p>
                                                                                        </Link>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                    );
                                                                }
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Category;